import React, { useEffect } from "react";

import { useHistory } from "react-router";

const Authenticated: React.FC = ({ children }): JSX.Element => {
	const history: any = useHistory();
	const validateLoginId = localStorage.getItem("validate_login_id");
	const userToken = localStorage.getItem("user_token");

	useEffect((): void => {
		if (!userToken) return history.push("/auth/send-otp");
		if (!validateLoginId || !userToken) {
			localStorage.clear();
			return history.push("/auth/login");
		}
	});

	return <div>{children}</div>;
};

export default Authenticated;
